/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface ICalendarAppBaseText {
    applyPromoCodeButtonText: string;
    buyTicketCtaDefaultText: string;
    buyTicketCtaUrlFormat: string;
    calendarAppHeading: string;
    calendarControlsHeading: string;
    calendarDoneLoadingLabel: string;
    calendarFiltersHeading: string;
    calendarKeyword: string;
    calendarLoadingLabel: string;
    categoryFilterLabelText: string;
    categorySelectAllDropdownOption: string;
    clearAllButtonText: string;
    emptyDayMessaging: string;
    emptyMonthMessaging: string;
    fallbackThumbnailImageSrc: string;
    filterCloseButtonLabel: string;
    filterOpenButtonLabel: string
    gridViewHeading: string;
    gridViewModeButtonText: string;
    lastMonthToDisplay: string;
    listViewHeading: string;
    listViewModeButtonText: string;
    loadMoreEventsButtonText: string;
    mainBody: string;
    monthDropdownDescriptionText: string;
    openFiltersButtonText: string;
    pluralEventsText: string;
    productionFilterLabelText: string;
    productionSelectAllDropdownOption: string;
    promoCodeDescriptionText: string;
    singleEventText: string;
    venueFilterLabelText: string;
    venueSelectAllDropdownOption: string;
    viewDetailDtaDefaultText: string;

    // Not from api but ~about~ api
    requesting: boolean;
    apiError: any;
}

export const defaultBaseText: ICalendarAppBaseText = {
    applyPromoCodeButtonText: 'Apply Code',
    buyTicketCtaDefaultText: 'Purchase Tickets',
    buyTicketCtaUrlFormat: '',
    calendarAppHeading: "Calendar",
    calendarControlsHeading: "Calendar Controls",
    calendarDoneLoadingLabel: "Calendar has loaded",
    calendarFiltersHeading: "Calendar Filters",
    calendarKeyword: '',
    calendarLoadingLabel: "Calendar is loading",
    categoryFilterLabelText: 'Filter by Category',
    categorySelectAllDropdownOption: 'Series/Genre',
    clearAllButtonText: "Clear All",
    emptyDayMessaging: 'There are no events',
    emptyMonthMessaging: 'There are no events',
    fallbackThumbnailImageSrc: "",
    filterCloseButtonLabel: "Close Filter Dialog",
    filterOpenButtonLabel: "Open Filter Dialog",
    gridViewHeading: "Calendar Grid",
    gridViewModeButtonText: 'Grid View',
    lastMonthToDisplay: '',
    listViewHeading: "Calendar List",
    listViewModeButtonText: 'List View',
    loadMoreEventsButtonText: 'Load More',
    mainBody: '',
    monthDropdownDescriptionText: "Select month",
    openFiltersButtonText: "Filters",
    pluralEventsText: "events",
    productionFilterLabelText: 'Performances',
    productionSelectAllDropdownOption: 'All Productions',
    promoCodeDescriptionText: "Promo code",
    singleEventText: "event",
    venueFilterLabelText: 'Venue',
    venueSelectAllDropdownOption: 'All Venues',
    viewDetailDtaDefaultText: '',

    requesting: false,
    apiError: null,
}